
<template>
   <v-layout row wrap>
      <v-flex class="xs12">
         <v-card>
            <v-toolbar color="brown lighten-1" dark dense>
               <v-toolbar-title>
                  <h4>Choisissez le repas à éditer</h4>
               </v-toolbar-title>

               <v-spacer></v-spacer>

               <v-dialog
                  ref="dialog"
                  v-model="pickerDateModal"
                  persistent
                  lazy
                  full-width
                  width="290px"
               >
                  <v-btn flat dark slot="activator">{{ displayDate }}</v-btn>
                  <v-date-picker
                     v-model="pickerDate"
                     scrollable
                     locale="fr-FR"
                     :first-day-of-week="1"
                     :max="new Date().toISOString().substr(0, 10)"
                  >
                     <v-spacer></v-spacer>
                     <v-btn flat color="primary" @click="pickerDateModal = false">Annuler</v-btn>
                     <v-btn flat color="primary" @click="changeDate(pickerDate); pickerDateModal = false">Choisir</v-btn>
                  </v-date-picker>

                  <v-btn icon slot="activator">
                     <v-icon>edit</v-icon>
                  </v-btn>

               </v-dialog>

               <v-spacer></v-spacer>

               <v-btn flat dark @click.stop="openFractionningDialog">Fractionnement...</v-btn>

            </v-toolbar>


            <v-layout row wrap>
               <v-flex class="xs12">
                  <v-tabs grow dark color="brown lighten-1" v-model="currentIndex">
                     <v-tabs-slider color="yellow"></v-tabs-slider>
                     <v-tab router v-for="type, index in mealTypes"
                           :disabled="!isMealPresent(index)" :key="index" @click.stop="changeIndex(index)">
                        {{ mealNames[index] }}
                     </v-tab>
                  </v-tabs>
               </v-flex>

               <v-flex class="xs12">
                  <router-view name="mealAssessment"></router-view>
               </v-flex>

               <v-flex class="xs12 sm8">
                  <router-view name="mealElements"></router-view>
               </v-flex>
               <v-flex class="xs12 sm4">
                  <router-view name="favorites" @addFavorite="addFavorite"></router-view>
               </v-flex>
            </v-layout>
            
         </v-card>
      </v-flex>

      <fractionning-dialog v-if="fractionningDialog" @close="fractionningDialog = false"
            :title='"Fractionnement de la journée"'
            :value="editedFractionning"
            @input="setFractionning" @cancel="cancelFractionning"
      />

   </v-layout>
</template>

<script>
   import moment from 'moment'
   import _ from 'lodash'
   import Vue from 'vue'
   const path = require('path')
   import fuzzy from '@/utilities/fuzzy.js'
   import config from '@/config'
   import FractionningDialog from '@/components/meals/FractionningDialog.vue'

   export default {

      props: {
         userId: Number,
         baseRoute: String,
      },

      components: {
         FractionningDialog: FractionningDialog,
      },

      async mounted () {
         let today = moment().format('YYYY-MM-DD')
         this.changeDate(today)
      },

      data () {
         return {
            currentDate: null,
            currentIndex: null,

            pickerDateModal: null,
            pickerDate: moment().format('YYYY-MM-DD'),
            fractionningDialog: false,
            editedFractionning: {},
         }
      },

      computed: {
         displayDate () {
            return moment(this.currentDate).format("dddd, Do MMMM YYYY")
         },
         fractionning() {
            if (this.userId && this.currentDate && this.$store.state.meals.user2date2fractionning[this.userId] && this.$store.state.meals.user2date2fractionning[this.userId][this.currentDate]) {
               let fractionningId = this.$store.state.meals.user2date2fractionning[this.userId][this.currentDate]
               return this.$store.state.meals.fractionnings[fractionningId]
            } else {
               return null
            }
         },
         mealTypes() {
            return config.MEAL_TYPES
         },
         mealNames() {
            return config.MEAL_TYPE_LIST.map(index => config.MEAL_TYPES[index]['name'])
         },
         defaultMealIndexes() {
            return config.MEAL_TYPE_LIST.filter(index => config.MEAL_TYPES[index]['default'])
         },

      },

      methods: {
         isMealPresent(index) {
            return this.fractionning && this.fractionning.mealPresenceArray.indexOf(parseInt(index)) !== -1
         },
         openFractionningDialog() {
            this.fractionningDialog = true
            this.editedFractionning = _.cloneDeep(this.fractionning)
         },
         setFractionning() {
            // store edited fractionning
            this.$store.dispatch('meals/PUT_FRACTIONNING', this.editedFractionning)
            // compare `editedFractionning` && `fractionning` && add/delete meals accordingly
            this.editedFractionning.mealPresenceArray.forEach(index => {
               if (this.fractionning.mealPresenceArray.indexOf(index) === -1) {
                  // add new meal
                  this.$store.dispatch('meals/POST_USER_MEAL', { user: this.userId, date: this.currentDate, index: index, extra: {} })
               }
            })
            this.fractionning.mealPresenceArray.forEach(index => {
               if (this.editedFractionning.mealPresenceArray.indexOf(index) === -1) {
                  // delete existing meal
                  let mealId = this.$store.state.meals.user2date2index2meal[this.userId][this.currentDate][index]
                  this.$store.dispatch('meals/DELETE_USER_MEAL', this.$store.state.meals.meals[mealId])
               }
            })
            // fetch reactive data && change route
            // ??? necessary ???
            this.fetchCurrentMealAndFavoritesAndChangeRoute()
         },

         cancelFractionning() {
            // fetch reactive data && change route
            this.fetchCurrentMealAndFavoritesAndChangeRoute()
         },

         async changeDate(date) {
            this.currentDate = date
            let fractionning = await this.$store.dispatch('meals/GET_FRACTIONNING', { userId: this.userId, date: this.currentDate  })
            if (fractionning === null) {
               // create default fractionning at this date
               await this.$store.dispatch('meals/POST_FRACTIONNING', {
                  user: this.userId,
                  date: this.currentDate,
                  mealPresenceArray: this.defaultMealIndexes
               })
               // then create all meals of default fractionning
               this.defaultMealIndexes.forEach(index => {
                  this.$store.dispatch('meals/POST_USER_MEAL', { user: this.userId, date: this.currentDate, index: index, extra: {} })
               })
               // then open fractionning dialog
               this.openFractionningDialog()
            } else {
               // update currentIndex in the case where it does not exist for the new fractionning
               if (this.currentIndex === null) this.currentIndex = 2 // default initial value
               if (fractionning.mealPresenceArray.indexOf(this.currentIndex) === -1) {
                  // set it to the first existing index of new fractionning
                  this.currentIndex = fractionning.mealPresenceArray[0]
               }
              // fetch reactive data && change route
               this.fetchCurrentMealAndFavoritesAndChangeRoute()
            }
         },

         changeIndex(index) {
            // update currentIndex
            this.currentIndex = index
            // fetch reactive data && change route
            this.fetchCurrentMealAndFavoritesAndChangeRoute()
         },

         async addFavorite(favorite) {
            // create && add meal element from favorite
            let portionWeight = fuzzy.parse(favorite.portion_weight)
            let weight = fuzzy.multiplyByScalar(portionWeight, parseFloat(favorite.nbportion))
            let mealId = this.$store.state.meals.user2date2index2meal[this.userId][this.currentDate][this.currentIndex]
            let mealElement = { meal: mealId, food: favorite.food, weight: fuzzy.format(weight), portion: favorite.portion, nbportion: favorite.nbportion }
            this.$store.dispatch('meals/POST_MEAL_ELEMENT', mealElement)
            // increment favorite count
            let favoriteCopy = Object.assign({}, favorite)
            favoriteCopy.count += 1
            this.$store.dispatch('meals/PUT_FAVORITE', favoriteCopy)
            // fetch favorite's associated foodPortion
            let foodPortion = await this.$store.dispatch('meals/GET_FOODPORTION', favorite.portion)
            // then fetch associated food and food's nutdata
            this.$store.dispatch('meals/GET_FOOD', foodPortion.food)
            this.$store.dispatch('meals/GET_FOOD_NUTDATA', foodPortion.food)
         },

         fetchCurrentMealAndFavoritesAndChangeRoute() {
            // fetch meal
            let self = this
            this.$store.dispatch('meals/GET_USER_MEAL', { userId: this.userId, date: this.currentDate, index: this.currentIndex })
            .then(function(meal) {
               // then fetch meal elements
               return self.$store.dispatch('meals/GET_MEAL_ELEMENTS', meal.id)
            })
            .then(function(mealElements) {
               // then fetch associated Food, FoodPortion, NutData for each MealElement
               mealElements.forEach(mealElement => {
                  let foodId = mealElement.food
                  if (mealElement.foodPortion) {
                     self.$store.dispatch('meals/GET_FOOD_PORTION', mealElement.foodPortion)
                     .then(function(foodPortion) {
                        if (!foodId) foodId = foodPortion.food
                     })
                  }
                  self.$store.dispatch('meals/GET_FOOD', foodId)
                  self.$store.dispatch('meals/GET_FOOD_NUTDATA', foodId)
               })
            })
            // fetch favorites
            this.$store.dispatch('meals/GET_FAVORITES', { userId: this.userId, index: this.currentIndex })
            // fetch nutrients
            this.$store.dispatch('meals/GET_NUTRIENTS')
            // change route
            let newRoute = path.join(this.baseRoute, moment(this.currentDate).format("YYYY-MM-DD"), `${this.currentIndex}`)
            this.$router.push(newRoute)
         },
      }
   }
</script>



// WEBPACK FOOTER //
// NutriEduc.vue?373eb119